module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_lg",
    attrs: {
      "id": "page_not_found"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span_12_xs"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('p', [_vm._v("Sorry, the page you're looking for was not found.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c18a5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404/404.vue
// module id = 571
// module chunks = 1